export default __webpack_public_path__ + "static/media/100-assurancefuneral.f38bbb3c.svg";